import { useCreateContext } from '@vision/ui/hooks/useCreateContext';
import type { Filter, Meta } from '@vision/ui/interfaces';

export type DataGridContext = Partial<{
  applyFilter: (key: string, value: string) => void;
  updateFilter: (filter: Filter, key: string) => void;
  meta: Meta;
}>;

export const [DataGridContextProvider, useDataGridContext] = useCreateContext<DataGridContext>();
